import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  faqsData: [],
  error: "",
  success: false,
  status: "",
};

const fetchFaqs = createAsyncThunk("fetch/faqs", async () => {
  try {
    const result = await axios.get(`${process.env.REACT_APP_CMS_URL}/faqs`, {
      commonHeaderNotRequired: true,
    });
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const faqsSlice = createSlice({
  name: "faqs",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchFaqs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchFaqs.fulfilled, (state, action) => {
      state.loading = false;
      state.faqsData = action?.payload?.data;
      //   state.success = action?.payload;
      state.error = "";
    });
    builder.addCase(fetchFaqs.rejected, (state, action) => {
      state.loading = false;
      state.faqsData = [];
      state.error = action.error.message;
    });
  },
});

export default faqsSlice.reducer;
export { fetchFaqs };
